'use client';

import React, { useState } from 'react';
import LinkLikeButton from '../../shared/link-like-button';
import QRComponent from '../qr-component';
import {
  ResponseBankDigitalOnBoardingInfo,
  ResponseStoreFrontDigitalOnboardingDetail,
} from '@/src/interfaces/data-contracts';
import { Button } from '../../ui/button/button';

interface IDobCardButtons {
  product: ResponseBankDigitalOnBoardingInfo | ResponseStoreFrontDigitalOnboardingDetail;
  isMobile: boolean;
  isDetailPage: boolean;
}

export const DobCardButtons: React.FC<IDobCardButtons> = ({ product, isMobile, isDetailPage = false }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };
  return (
    <div className="flex justify-between gap-3" data-testid="dobCardButtons">
      {product.recourseLink && !isDetailPage && (
        <LinkLikeButton
          className="h-[48px] min-w-[106px] rounded-lg text-sm font-bold md:min-w-[120px] md:text-base"
          href={`${product.detailLink}`}
          text={'İncele'}
          external
        />
      )}

      {product.recourseLink && (!product.isQrPopUpActive || isMobile) && (
        <LinkLikeButton
          className="h-[48px] w-full rounded-lg text-sm font-bold md:min-w-[182px] md:text-base"
          target={product.target}
          href={product.recourseLink}
          text={product.buttonText ?? 'Müşteri Ol'}
        />
      )}

      {!isMobile && product.isQrPopUpActive && (
        <>
          <Button
            className="h-[48px] w-full rounded-lg text-sm font-bold md:min-w-[182px] md:text-base"
            text={product.buttonText ?? 'Müşteri Ol'}
            onClick={openPopup}
          />
          <QRComponent closePopup={closePopup} isPopupOpen={isPopupOpen} product={product} />
        </>
      )}
    </div>
  );
};
